import { Component, Input, ChangeDetectionStrategy, inject } from '@angular/core';
import { ThemeService } from 'src/app/core/services/theme/theme.service';
import { GameId } from 'src/app/model/game/game-id';

@Component({
  selector: 'app-game-icon',
  templateUrl: './game-icon.component.html',
  styleUrls: ['./game-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GameIconComponent {
  @Input({ required: true }) game!: GameId;
  @Input() size = '--spacing-4x-large';

  private themeService = inject(ThemeService);

  get sizeCss(): string {
    return `var(${this.size})`;
  }

  get gameIcon(): string {
    return `assets/images/${this.themeService.imagesFolder()}/${this.game}-icon.svg`;
  }
}
